module.exports = __webpack_public_path__ + "bb6bb3b08fb190e35635d079c47afac0.png";